import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { take, map, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { DatabaseService } from 'src/app/shared/services/database/database.service';
import { SnackService } from 'src/app/shared/services/snack/snack.service';

@Injectable({
  providedIn: 'root'
})
export class EditorGuard implements CanActivate, CanLoad {

  
  constructor(private auth: AuthService, private db: DatabaseService, private router: Router, private snack: SnackService){}
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.db.userRole$.pipe(
      take(1),
      map(userRole => userRole && (userRole.role == 'editor' || userRole.role == 'admin')),
      tap(isEditor => {
        if(!isEditor){
          this.router.navigate['/'];
          this.auth.signOutUser();
          this.snack.generalSnack('Not Authorized!', 'Ok');
          return false;
        } else return true;
      })
    )
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
      return this.db.userRole$.pipe(
        take(1),
        map(userRole => userRole && (userRole.role == 'editor' || userRole.role == 'admin')),
        tap(isEditor => {
          if(!isEditor){
            this.router.navigate['/'];
            this.auth.signOutUser();
            this.snack.generalSnack('Not Authorized!', 'Ok');
            return false;
          } else return true;
        })
      )
  }
}
